import React from "react";
import "./enquirymodal.css";
import { FaTimes } from "react-icons/fa";

const EnquiryModal = ({ onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box-enquiry" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn-enquiry" onClick={onClose}>
          <FaTimes />
        </button>
        <iframe
          src="https://api.leadconnectorhq.com/widget/form/8AyZWnyf0gjNDGotbECt"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            borderRadius: "3px",
          }}
          id="inline-8AyZWnyf0gjNDGotbECt"
          data-layout="{'id':'INLINE'}"
          data-trigger-type="alwaysShow"
          data-trigger-value=""
          data-activation-type="alwaysActivated"
          data-activation-value=""
          data-deactivation-type="neverDeactivate"
          data-deactivation-value=""
          data-form-name="Generic Inquiry Form"
          data-height="489"
          data-layout-iframe-id="inline-8AyZWnyf0gjNDGotbECt"
          data-form-id="8AyZWnyf0gjNDGotbECt"
          title="Generic Inquiry Form"
        ></iframe>
      </div>
    </div>
  );
};

export default EnquiryModal;
